<div *ngIf="isDesktop||isTablet">
    <mat-grid-list [cols]="cols" rowHeight="100px" class="banner">  
        <mat-grid-tile class="logoTile"></mat-grid-tile>
      <mat-grid-tile>
        <div>
          <div class="title" style="text-align: center;">
            Council Elections
          </div><br/>
          <div class="sub-title" style="text-align: center;">{{subTitle}}</div>
        </div>
      </mat-grid-tile>
  
      <mat-grid-tile >
        <a class="logo" href="https://ecsa.sa.gov.au" target="_blank" rel="noopener">
          <img src="../assets/logo-mobile.svg" style="height: 80px;" alt="Electoral Commission South Australia">
        </a>
      </mat-grid-tile>
  
    </mat-grid-list>
  </div>
  
  <div *ngIf="isMobile">
    <mat-grid-list [cols]="cols" rowHeight="60px" class="banner">
  
      <mat-grid-tile class="logoTile">
        <div class="hamburger">
          <button mat-icon-button (click)="toggleSideNav()">
            <mat-icon>menu</mat-icon>
          </button>
        </div>
      </mat-grid-tile>
  
      <mat-grid-tile>
        <div>
          <div class="title-phone" style="text-align: center;">
            Council Elections
          </div>
        </div>
      </mat-grid-tile>
  
      <mat-grid-tile >
        <img src="../assets/logo-mobile.svg" style="height: 45px;" alt="Electoral Commission South Australia">
      </mat-grid-tile>
  
    </mat-grid-list>
  </div>
  
  <mat-sidenav-container *ngIf="isMobile" class="ecsa-sidnav-container-phone">
    <mat-sidenav role="navigation" 
      class="sideMenu" 
      [fixedInViewport]="optionsPhone.fixed"
      [fixedTopGap]="optionsPhone.top" 
      [fixedBottomGap]="optionsPhone.bottom" 
      [(opened)]="showSideNav">
      <app-side-menu-lge></app-side-menu-lge>
    </mat-sidenav>
    <mat-sidenav-content >
        <div *ngIf="currentPage===PageTypeEnum.Loading">
            <app-page-loading></app-page-loading>
          </div>
          <div *ngIf="currentPage===PageTypeEnum.LGEResults">
            <app-page-lge-results-phone></app-page-lge-results-phone>
          </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
  
  <mat-sidenav-container *ngIf="isDesktop||isTablet" fxFlexFill class="ecsa-sidnav-container">
    <mat-sidenav role="navigation" 
      class="sideMenu" opened mode="side" 
      [fixedInViewport]="options.fixed"
      [fixedTopGap]="options.top" 
      [fixedBottomGap]="options.bottom" 
      [style.maxWidth]="'400px'" 
      [style.width]="'25%'">
      <app-side-menu-lge></app-side-menu-lge>
    </mat-sidenav>
    <mat-sidenav-content>
      <div *ngIf="currentPage===PageTypeEnum.Loading">
        <app-page-loading></app-page-loading>
      </div>
      <div *ngIf="currentPage===PageTypeEnum.LGEResults">
        <app-page-lge-results></app-page-lge-results>
      </div>

  
    </mat-sidenav-content>
  </mat-sidenav-container>
    
  <!-- <mat-toolbar class="ecsa-footer"></mat-toolbar> -->